import { defineComponent as p, openBlock as l, createElementBlock as a, mergeProps as h, unref as o, renderSlot as i, createElementVNode as e, createCommentVNode as u } from "vue";
import { useScalarIcon as m } from "../hooks/useScalarIcon.js";
const g = { key: 0 }, A = { key: 1 }, v = { key: 2 }, H = { key: 3 }, Z = { key: 4 }, f = { key: 5 }, k = {
  name: "ScalarIconArrowFatLeft"
}, L = /* @__PURE__ */ p({
  ...k,
  props: {
    label: {},
    weight: {}
  },
  setup(r) {
    const s = r, { bind: V, weight: n } = m(s);
    return (d, t) => (l(), a("svg", h({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, o(V)), [
      i(d.$slots, "default"),
      o(n) === "bold" ? (l(), a("g", g, t[0] || (t[0] = [
        e("path", { d: "M208,68H132V32a12,12,0,0,0-20.49-8.48l-96,96a12,12,0,0,0,0,17l96,96A12,12,0,0,0,132,224V188h76a20,20,0,0,0,20-20V88A20,20,0,0,0,208,68Zm-4,96H120a12,12,0,0,0-12,12v19L41,128l67-67V80a12,12,0,0,0,12,12h84Z" }, null, -1)
      ]))) : o(n) === "duotone" ? (l(), a("g", A, t[1] || (t[1] = [
        e("path", {
          d: "M216,88v80a8,8,0,0,1-8,8H120v48L24,128l96-96V80h88A8,8,0,0,1,216,88Z",
          opacity: "0.2"
        }, null, -1),
        e("path", { d: "M208,72H128V32a8,8,0,0,0-13.66-5.66l-96,96a8,8,0,0,0,0,11.32l96,96A8,8,0,0,0,128,224V184h80a16,16,0,0,0,16-16V88A16,16,0,0,0,208,72Zm0,96H120a8,8,0,0,0-8,8v28.69L35.31,128,112,51.31V80a8,8,0,0,0,8,8h88Z" }, null, -1)
      ]))) : o(n) === "fill" ? (l(), a("g", v, t[2] || (t[2] = [
        e("path", { d: "M224,88v80a16,16,0,0,1-16,16H128v40a8,8,0,0,1-13.66,5.66l-96-96a8,8,0,0,1,0-11.32l96-96A8,8,0,0,1,128,32V72h80A16,16,0,0,1,224,88Z" }, null, -1)
      ]))) : o(n) === "light" ? (l(), a("g", H, t[3] || (t[3] = [
        e("path", { d: "M208,74H126V32a6,6,0,0,0-10.24-4.24l-96,96a6,6,0,0,0,0,8.48l96,96A6,6,0,0,0,126,224V182h82a14,14,0,0,0,14-14V88A14,14,0,0,0,208,74Zm2,94a2,2,0,0,1-2,2H120a6,6,0,0,0-6,6v33.51L32.49,128,114,46.49V80a6,6,0,0,0,6,6h88a2,2,0,0,1,2,2Z" }, null, -1)
      ]))) : o(n) === "regular" ? (l(), a("g", Z, t[4] || (t[4] = [
        e("path", { d: "M208,72H128V32a8,8,0,0,0-13.66-5.66l-96,96a8,8,0,0,0,0,11.32l96,96A8,8,0,0,0,128,224V184h80a16,16,0,0,0,16-16V88A16,16,0,0,0,208,72Zm0,96H120a8,8,0,0,0-8,8v28.69L35.31,128,112,51.31V80a8,8,0,0,0,8,8h88Z" }, null, -1)
      ]))) : o(n) === "thin" ? (l(), a("g", f, t[5] || (t[5] = [
        e("path", { d: "M208,76H124V32a4,4,0,0,0-6.83-2.83l-96,96a4,4,0,0,0,0,5.66l96,96A4,4,0,0,0,124,224V180h84a12,12,0,0,0,12-12V88A12,12,0,0,0,208,76Zm4,92a4,4,0,0,1-4,4H120a4,4,0,0,0-4,4v38.34L29.66,128,116,41.66V80a4,4,0,0,0,4,4h88a4,4,0,0,1,4,4Z" }, null, -1)
      ]))) : u("", !0)
    ], 16));
  }
});
export {
  L as default
};
